<template>
    <layout-basic>
        <v-container>
            <section class="container-new banner-text">
                <v-row align="center" justify="center">
                    <v-col cols="12" md="12" class="text-center">
                        <div class="relative">
                            <img class="about-banner" src="/static/pages/about/banner.png" />
                            <img class="about-overlay" src="/static/pages/about/banner-overlay.png" />
                        </div>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center">
                    <v-col cols="12" md="12" class="text-center">
                        <div class="about-heading">
                            <h1 class="font-sora">We’re a team with extensive L&D and SME <br/>experience, and this sits firmly at our roots</h1>
                        </div>
                    </v-col>
                    <v-col cols="12" md="10" lg="6">
                        <div class="about-content">
                            <p class="fs-18">Our mission is to offer simple and practical learning solutions to help you manage compliance and develop your people in the workplace. We’re here to make life easier for you and your teams.</p>
                            <p class="fs-18">Using our 20 years+ experience working in the SME sector, our solutions are designed with you in mind. Improve is designed for simple and practical roll out, whatever industry you’re in.</p>
                            <p class="fs-18">Learning and development sits at the heart of what we do. We support you to inspire and develop your teams by investing in them, creating a place where people want to work and deliver success.</p>
                            <p class="fs-18">So, IMPROVE was born. And we’ve been enabling people to learn what they need, when they need it, where-ever they are ever since. A truly on-demand experience!</p>
                            <!--<p><h3>Our story:</h3></p>
                            <p class="fs-18">Working with thousands of SMEs across the UK it became clear to us that quality online learning wasn’t something that was accessible to most. Businesses needed both online content that addressed the core compliance, development and training needs across their business as well as an easy-to-use system to administer it. Most solutions were either too expensive or too complex to use.</p>
                            <p class="fs-18">So, Improve was born. We’ve been enabling people to learn what they need, when they need it, where-ever they are.</p>-->
                        </div>
                    </v-col>
                </v-row>
                <v-row class="text-center mt-10">
                    <v-col cols="12" md="12">
                        <v-btn href="/why-improve" color="primary" class="home_login banner_why">Why IMPROVE?</v-btn>
                        <v-btn :href="directUrl + '/#/signup?ref=website'" color="secondary" class="try_free">Try For Free</v-btn>
                    </v-col>
                </v-row>
            </section>
        </v-container>
    </layout-basic>
</template>

<script>
    import LayoutBasic from "@/layouts/Dashboard";
    import { IMPROVE_CONFIG } from '@/config.js';
    export default {
        name: "About",
        metaInfo() {
            return { 
                title: "Know IMPROVE: UK's 1st Online Learning Platform for SMEs",
                meta: [
                    // Meta Description
                    { name: 'description', content: "Get to know about IMPROVE, UK's 1st online microlearning platform, designed for SMEs. Meet the team behind IMPROVE." },
                    
                    // Keywords
                    { name: 'keywords', content: "IMPROVE, online learning platform, SMEs, UK microlearning platform, meet the team, small business education" },
                    
                    // Open Graph / Facebook Tags
                    { property: 'og:title', content: "Know IMPROVE: UK's 1st Online Learning Platform for SMEs" },
                    { property: 'og:description', content: "Get to know about IMPROVE, UK's 1st online microlearning platform, designed for SMEs. Meet the team behind IMPROVE." },
                    { property: 'og:image', content: 'https://www.improve.online/static/seo.png' },
                    { property: 'og:type', content: 'website' },
                    { property: 'og:url', content: 'https://www.improve.online/about-us' },
                    
                    // Twitter Card Tags
                    { name: 'twitter:card', content: 'summary_large_image' },
                    { name: 'twitter:title', content: "Know IMPROVE: UK's 1st Online Learning Platform for SMEs" },
                    { name: 'twitter:description', content: "Get to know about IMPROVE, UK's 1st online microlearning platform, designed for SMEs. Meet the team behind IMPROVE." },
                    { name: 'twitter:image', content: 'https://www.improve.online/static/seo.png' }
                ],
                link: [
                    // Canonical URL
                    { rel: 'canonical', href: 'https://www.improve.online/about-us' }
                ]
            }
        },
        components: {
            LayoutBasic
        },
        data() {
            return {
                directUrl: IMPROVE_CONFIG.DIRECT_URL,
            }
        }
    };
</script>
